import { Directive, ElementRef, Input } from '@angular/core';
import { SlIdContext } from './sl-id-context';

@Directive({ selector: '[sl-for]' })
export class SlForDirective {
  constructor(private el: ElementRef, private ids: SlIdContext) {}

  @Input('sl-for')
  set localId(value: string) {
    if (!value) {
      this.el.nativeElement.removeAttribute('for');
      return;
    }
    this.el.nativeElement.setAttribute('for', this.ids.id(value));
    this.el.nativeElement.removeAttribute('sl-for');
  }
}
